import {IOGateway} from '@interopio/gateway';
export import Logger = IOGateway.Logging.Logger;

export default function getLogger(name: string): Logger {
    return IOGateway.Logging.getLogger(`gateway.server.${name}`);
}
